module.exports = __webpack_public_path__ + "img/camas.d9b939fe.svg";